<template>
  <div class='approvalDetail' style='position: relative;'>
    <a-spin :spinning='loading'>
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerImageInfo')"
        type='inner'
        v-viewer='viewOptions'>
        <div v-for='(item, index) in imageInfos' :key='item.imgType'>
          <div class='file-box'>
            <div class='file-item'>
              <p class='file-label'>{{ FILE_TYPE[item.imgType] }}</p>
              <img class='file-preview' :src='item.imgUrl' preview='0'>
            </div>
          </div>
        </div>
      </a-card>
      <!--  订单信息-->
      <a-card
        :title="$t(I18N_KEY.ORDER + 'orderInfo')"
        type='inner'
        style='margin-top: 24px;'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'productName')">{{ orderInfo.productName }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applyAmt')">{{ orderInfo.applyAmt }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'submissionTime')">{{ orderInfo.submitTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applicationDeadline')">{{ orderInfo.applyDuration }}
          </detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderNo')">{{ orderInfo.orderNo }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderType')">{{ $t(ORDER_TYPE_CN[orderInfo.orderType]) }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentAmt')">{{ orderInfo.paymentAmt }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentTime')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.paymentTime }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'extendAmoumt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.extendAmoumt }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'repaymentAmount')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.repaymentAmount }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'settleAmt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.settleAmt }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'lateFee')">{{ orderInfo.lateFee }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'overdueDayC')">{{ orderInfo.overdueDays }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'createTime')">{{ orderInfo.submitTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'payoutId')">{{ orderInfo.payoutId }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankName')">
            <Dict :dict-code='DICT_CODE.BANKLISTF' :value='bankCardInfo.bankAccountName' />
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}
          </detail-list-item>
        </detail-list>
      </a-card>
      <!--审核客户信息-->
      <a-card
        style="margin-top: 24px"
        :title="$t(I18N_KEY.CUSTOMER + 'customerBasicInfo')"
        type="inner">
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'names')">{{ basicInfo.names }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'surnames')">{{ basicInfo.surnames }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'curp')">{{ basicInfo.curp }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'collectType')">{{ COLLECT_TYPE[bankCardInfo.collectType] }}</detail-list-item>
          <detail-list-item :term="$t('birthday')">{{ basicInfo.birthday }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')">{{ REBORROW_FLAG[basicInfo.reborrowFlag] }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'createTime')">{{ basicInfo.createdTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'fb')">{{ detailInfo.fb }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'creatEmail')">{{ basicInfo.email }}</detail-list-item>
        </detail-list>
      </a-card>
<!--      <a-card-->
<!--        :title="$t(I18N_KEY.ORDER + 'examineCustomerInfo')"-->
<!--        type='inner'-->
<!--        style='margin-top: 24px;'>-->
<!--        <detail-list>-->
<!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'mobile')">{{ basicInfo.mobileNo }}</detail-list-item>-->
<!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'age')">{{ basicInfo.age }}</detail-list-item>-->
<!--          <detail-list-item :term="$t('birthday')">{{ basicInfo.birthday }}</detail-list-item>-->
<!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'AadhaarName')">{{ basicInfo.aadhaarName }}</detail-list-item>-->
<!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'panName')">{{ basicInfo.panName }}</detail-list-item>-->
<!--          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountName')">{{ basicInfo.panName }}</detail-list-item>-->
<!--          &lt;!&ndash;<detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'epochScore')">{{ basicInfo.epochScore }}</detail-list-item>&ndash;&gt;-->
<!--          &lt;!&ndash;<detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'modelScore')">{{ basicInfo.modelScore }}</detail-list-item>&ndash;&gt;-->
<!--          <detail-list-item :term="$t(I18N_KEY.ORDER + 'sxCreditScore')">{{ orderInfo.sxCreditScore }}-->
<!--          </detail-list-item>-->
<!--          <detail-list-item :term="$t(I18N_KEY.ORDER + 'sxCheatScore')">{{ orderInfo.sxCheatSccore }}</detail-list-item>-->
<!--        </detail-list>-->
<!--      </a-card>-->
<!--  客户联系人信息-->
        <a-card
          style='margin-top: 24px ;'
          :title="$t(I18N_KEY.CUSTOMER + 'customerLinkInfo')"
          type='inner'>
          <a-table
            :columns='linkColumns'
            :dataSource='linkmanInfos'
            :pagination='false'
            bordered
            ref='table'
            size='middle'
            :rowKey='(record) => record.index'>
            <span slot='contactType' slot-scope='text' :value='text'>{{ $t(CONTACT_TYPE[text]) }}</span>
            <Dict slot='relationType' slot-scope='text' :dict-code='DICT_CODE.REALTIONSHIP' :value='text' />
          </a-table>
        </a-card>
<!--       审批记录-->
        <a-card
          type='inner'>
          <a-tabs v-model='currentTab'>
            <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'approvalRecord')" key='1' forceRender>
              <a-table
                :columns='examineColumns'
                :dataSource='examineSource'
                :pagination='false'
                bordered
                ref='table'
                size='middle'>
                <Dict slot='approveTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS'
                      :value='text' />
                <Dict slot='approveStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_STATUS' :value='text' />
              </a-table>
            </a-tab-pane>
          </a-tabs>
        </a-card>

      <!--  审批项信息  -->
      <a-card title='审批项信息' type='inner' v-if='showForm'>
        <div style='height: 50px'>
          <a-button type='primary' @click='submitInfo'>提交</a-button>
        </div>
        <div class='chose-one'>
          <div class='chose-one-item'>证件照片是否正常</div>
          <!--  选项信息   -->
          <div>
            <a-checkbox :value='0' :checked='Q_cust_image_normal' @change='radioOneChange($event)'>正常</a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeOne' :disabled='disable0ne'>
            <a-row>
              <a-col>
                <a-checkbox value='1'>缺少身份证或者无照片</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='2'>身份证接近过期</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='3'>身份证接近过期</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='4'>身份证已经过期</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='5'>身份证照片伪造</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='6'>复印身份证</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='7'>身份证伪造</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='8'>破损身份证</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='9'>身份证与本人不配</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='10'>身份证照片是粘贴的</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='11'>身份证照片不清晰</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='12'>身份证不清晰</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='13'>身份证照片太暗</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='14'>身份证照片不全</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='15'>身份证字体与正常不同</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='16'>身份证排版倾斜</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='17'>身份证上无签名</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='18'>其他</a-checkbox>
              </a-col>

            </a-row>
          </a-checkbox-group>
          <div class='chose-one-item'>活体是否正常</div>
          <div>
            <a-checkbox :value='0' :checked='Q_cust_living_body_normal' @change='radioTwoChange($event)'>正常
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeTwo' :disabled='disableTwo'>
            <a-row>
              <a-col>
                <a-checkbox value='1'>活体照片与身份证不匹配</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='2'>其他</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>

          <div class='chose-one-item'>联系人信息是否正常</div>
          <div>
            <a-checkbox :value='0' :checked='Q_cust_contactperson_normal' @change='radioThreeChange($event)'>正常
            </a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeThree' :disabled='disableThree'>
            <a-row>
              <a-col>
                <a-checkbox value='1'>联系人姓名异常</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='2'>联系人电话异常</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='3'>缺少联人</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='4'>其他</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <div class='chose-one-item'>电话接听是否正常</div>
          <div>
            <a-checkbox :value='0' :checked='Q_contact_phone_normal' @change='radioFourChange($event)'>正常</a-checkbox>
          </div>
          <a-checkbox-group @change='CheckBoxOnChangeFour' :disabled='disableFour'>
            <a-row>
              <a-col>
                <a-checkbox value='1'>电话号码不正确</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='2'>接不通电话</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='3'>电话为空</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='4'>电话号码不是本人的</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='5'>接听电话非本人</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='6'>非本人验证信息</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='7'>客户请求关闭订单</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='8'>客户不承认此订单</a-checkbox>
              </a-col>
              <a-col>
                <a-checkbox value='9'>其他</a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
          <div class='chose-one-item'>备注</div>
          <div>
            <a-textarea placeholder='请输入备注内容' @change='TextareaonChange($event)'>

            </a-textarea>
          </div>
        </div>
      </a-card>
    </a-spin>
    <div
      v-if='auditDrawer && !loading'
      :class="{ 'setting-drawer-handle': true, active: visible }" @click='handelDrawer(!visible)'>
      <a-icon type='double-left' v-if='!visible' />
      <a-icon type='double-right' v-if='visible' />
    </div>
    <!--    非空校验弹框-->
    <a-modal v-model='ModalVisible' title='操作提醒' @ok='handleOk'>
      <p>有必填未填写！！</p>
    </a-modal>
    <a-drawer
      v-if='auditDrawer'
      width='600'
      placement='right'
      title='审批'
      :visible='visible'
      :maskClosable='false'
      :getContainer='drawContainer'
      :wrapStyle="{height: 'calc(100% - 20px)',overflow: 'auto',paddingBottom: '20px'}"
      @close='closeDrawer'
    >
      <div class='audit-form'>
        <a-form :form='basicForm' layout='vertical'>

          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q1')">
            <a-radio-group
              v-decorator="['Q_cust_phone_get', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='2'>{{ $t(I18N_KEY.APPROVAL + 'noresponse') }}</a-radio>
              <a-radio value='3'>{{ $t(I18N_KEY.APPROVAL + 'invalidnumber') }}</a-radio>
              <a-radio value='4'>{{ $t(I18N_KEY.APPROVAL + 'switchoff') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'reject') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q2')">
            <a-radio-group
              v-decorator="['Q_cust_info_confirm', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q3')">
            <a-radio-group
              v-decorator="['Q_cust_phone_read', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q4')">
            <a-radio-group
              v-decorator="['Q_cust_Birth_read', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q5')">
            <a-radio-group
              v-decorator="['Q_cust_duration_amt_question', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q6')">
            <a-radio-group
              v-decorator="['Q_contact_phone_read', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='2'>{{ $t(I18N_KEY.APPROVAL + 'noresponse') }}</a-radio>
              <a-radio value='3'>{{ $t(I18N_KEY.APPROVAL + 'invalidnumber') }}</a-radio>
              <a-radio value='4'>{{ $t(I18N_KEY.APPROVAL + 'switchoff') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'reject') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.APPROVAL + 'q7')">
            <a-radio-group
              v-decorator="['Q_cust_contact_know', { initialValue: '1' }]">
              <a-radio value='1'>{{ $t(I18N_KEY.APPROVAL + 'yes') }}</a-radio>
              <a-radio value='0'>{{ $t(I18N_KEY.APPROVAL + 'no') }}</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="$t(I18N_KEY.ORDER + 'approvalRemark')">
            <a-textarea
              v-decorator="['remark']"
              :rows='4' />
          </a-form-item>
        </a-form>
      </div>
      <div class='footer'>
        <a-button style='marginRight: 8px' @click='closeDrawer'>
          {{ $t('cancel') }}
        </a-button>
        <a-button :loading='confirmLoading' @click='submitAuditForm' type='primary'>
          {{ $t('confirm') }}
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { DetailList } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import { REBORROW_FLAG, SEX, CONTACT_TYPE, ORDER_TYPE_CN, CURP_TYPE, COLLECT_TYPE } from '@/constants/status'
import Dict from '../modules/Dict'
import imageMixin from '@/mixins/image-mixin'
import { modExamineTaskUser, peopleExamine } from '@/webpublicapi/approval'

const DetailListItem = DetailList.Item
const I18N_KEY = {
  CUSTOMER: 'customer.',
  ORDER: 'order.',
  APPROVAL: 'approval.'
}

export default {
  props: {
    orderId: {
      type: [String, Number],
      default: undefined
    },
    custInfoId: {
      type: [String, Number],
      default: undefined
    },
    taskId: {
      type: [String, Number],
      default: undefined
    },
    auditDrawer: {
      type: Boolean,
      default: false
    },
    approvalStatus: {
      type: [String, Number],
      default: undefined
    }
  },
  components: {
    DetailList,
    DetailListItem,
    Dict
  },
  mixins: [imageMixin],
  data() {
    return {
      remarkValue: '',//备注栏的默认内容
      ModalVisible: false,//校验提示弹框
      showForm: false,//是否展示审批项信息 默认不显示 【approvalStatus】为2的时候
      //存储四个正常按钮的变量
      Q_cust_image_normal: false,
      Q_cust_living_body_normal: false,
      Q_cust_contactperson_normal: false,
      Q_contact_phone_normal: false,
      //非正常情况下多选的选项的数组
      image_normal_array: [],
      living_body_normal_array: [],
      contactperson_normal_array: [],
      ontact_phone_array: [],
      //是否禁用
      disable0ne: false,
      disableTwo: false,
      disableThree: false,
      disableFour: false,
      //子选项禁用时候的保留值
      childValueOne: [],
      childValueTwo: [],
      childValueThree: [],
      childValueFour: [],
      //传给后端的item
      chooseItems: [
        {
          'itemCode': 'Q_cust_image_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_cust_living_body_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_cust_contactperson_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_contact_phone_normal',
          'itemResult': []
        }
      ],
      I18N_KEY,
      REBORROW_FLAG,
      ORDER_TYPE_CN,
      SEX,
      CONTACT_TYPE,
      COLLECT_TYPE,
      visible: false,
      loading: true,
      confirmLoading: false,
      basicForm: this.$form.createForm(this),
      listItem: {},
      openDrawerCount: 0,
      currentTab: '1',
      linkColumns: [
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactType'),
          dataIndex: 'contactType',
          key: 'contactType',
          align: 'center',
          scopedSlots: { customRender: 'contactType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactRelationship'),
          dataIndex: 'relationType',
          key: 'relationType',
          align: 'center',
          scopedSlots: { customRender: 'relationType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactName'),
          dataIndex: 'contactName',
          key: 'contactName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactPhone'),
          dataIndex: 'contactPhone',
          key: 'contactPhone',
          align: 'center'
        }
      ],

      examineColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStaff'),
          dataIndex: 'examineUserName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTime'),
          dataIndex: 'examineTime',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTaskStatus'),
          dataIndex: 'approveTaskStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveTaskStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStatus'),
          dataIndex: 'approveStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalRemark'),
          dataIndex: 'comment',
          align: 'center'
        }
      ],
      FILE_TYPE: {
        'aadhaar_front': this.$t(I18N_KEY.CUSTOMER + 'aadhaarFront'),
        'aadhaar_back': this.$t(I18N_KEY.CUSTOMER + 'aadhaarBack'),
        'pan_front': this.$t(I18N_KEY.CUSTOMER + 'panFront'),
        'face_photo_list': this.$t(I18N_KEY.CUSTOMER + 'facePhotoList'),
        'card_front': this.$t(I18N_KEY.CUSTOMER + 'idcardFront'),
        'card_back': this.$t(I18N_KEY.CUSTOMER + 'idcardNegative')
      },
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 20
      }
    }
  },
  computed: {
    ...mapGetters('order', [
      'orderDetail',
      'examineLogList'
    ]),
    ...mapGetters('customer', [
      'customerDetail'
    ]),
    basicInfo() {
      return (this.customerDetail && this.customerDetail.basicInfo) || {}
    },
    detailInfo() {
      return (this.customerDetail && this.customerDetail.detailInfo) || {}
    },
    linkmanInfos() {
      return (this.customerDetail && this.customerDetail.linkmanInfos) || []
    },
    aadhaarInfo() {
      return (this.customerDetail && this.customerDetail.aadhaarInfo) || {}
    },
    panInfo() {
      return (this.customerDetail && this.customerDetail.panInfo) || {}
    },
    imageInfos() {
      return (this.customerDetail && this.customerDetail.imageInfos) || []
    },
    bankCardInfo() {
      return (this.customerDetail && this.customerDetail.bankCardInfo) || []
    },
    orderInfo() {
      return (this.orderDetail || {}).orderInfo || {}
    },
    examineSource() {
      return this.examineLogList || []
    }
  },
  mounted() {
    window.aa = this
    this.requestDetail(this.orderId)
    console.log('taskid------------>', this.taskId)
    console.log('approvalTaskStatustfsihvsljdibf!!!——————————————————————>', this.approvalStatus)
    if (this.approvalStatus === 2) {
      this.showForm = true
    } else {
      this.showForm = false
    }
  },
  methods: {
    ...mapActions('order', [
      'getOrderDetail',
      'getExamineLogList'
    ]),
    ...mapActions('approval', [
      'auditApproval',
      'getApprovalListItem'
    ]),
    ...mapActions('customer', [
      'getCustomerDetail'
    ]),
    TextareaonChange(e) {
      console.log('备注栏发生变化啦！！！', e)
      console.log('备注栏输入的内容', e.target._value)
      this.remarkValue = e.target._value
      console.log('备注栏输入的内容this.remarkValue--->', this.remarkValue)
    },
    handleOk(e) {
      console.log(e)
      this.ModalVisible = false
    },
    submitInfo() {
      console.log('点击了提交')
      // 证件照
      if (this.Q_cust_image_normal) {
        this.chooseItems[0].itemResult = [0]
      } else {
        this.chooseItems[0].itemResult = this.image_normal_array
      }
      //活动人员
      if (this.Q_cust_living_body_normal) {
        this.chooseItems[1].itemResult = [0]
      } else {
        this.chooseItems[1].itemResult = this.living_body_normal_array
      }
      //联系
      if (this.Q_cust_contactperson_normal) {
        this.chooseItems[2].itemResult = [0]
      } else {
        this.chooseItems[2].itemResult = this.contactperson_normal_array
      }
      //电话
      if (this.Q_contact_phone_normal) {
        this.chooseItems[3].itemResult = [0]
      } else {
        this.chooseItems[3].itemResult = this.ontact_phone_array
      }
      console.log('最后要传给后端的数组！！！', this.chooseItems)
      // 非空校验
      if (this.chooseItems[0].itemResult.length === 0 || this.chooseItems[1].itemResult.length === 0 || this.chooseItems[2].itemResult.length === 0 || this.chooseItems[3].itemResult.length == 0) {
        this.ModalVisible = true
      } else {
        peopleExamine({ taskId: this.taskId, items: this.chooseItems, remark: this.remarkValue }).then((res) => {
          if (res.code === 1000) {
            this.$message.success('Submitted successfully!')
            this.$emit('closeDetail')//关闭弹窗
            this.$emit('searchQuery')//刷新页面
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      }

    },
    radioOneChange(e) {
      console.log('e打印出来是什么ne', e)//可以拿到正常的下标0
      console.log('可以拿到正的下标吗？', e.target.value)//可以拿到正常的下标0
      this.Q_cust_image_normal = !this.Q_cust_image_normal
    },
    radioTwoChange(e) {
      this.Q_cust_living_body_normal = !this.Q_cust_living_body_normal
    },
    radioThreeChange(e) {
      this.Q_cust_contactperson_normal = !this.Q_cust_contactperson_normal
    },
    radioFourChange(e) {
      this.Q_contact_phone_normal = !this.Q_contact_phone_normal
    },
    CheckBoxOnChangeOne(checkedValues) {
      console.log('checked = ', checkedValues)
      this.image_normal_array = checkedValues
      this.childValueOne = checkedValues
      console.log('非正常情况多选的数组结果', this.image_normal_array)
    },
    CheckBoxOnChangeTwo(checkedValues) {
      this.living_body_normal_array = checkedValues
      this.childValueTwo = checkedValues
    },
    CheckBoxOnChangeThree(checkedValues) {
      this.contactperson_normal_array = checkedValues
      this.childValueThree = checkedValues
    },
    CheckBoxOnChangeFour(checkedValues) {
      this.ontact_phone_array = checkedValues
      this.childValueFour = checkedValues
    },
    drawContainer() {
      return document.querySelector('.ant-modal-wrap')
    },
    handelDrawer(visible) {
      if (visible) {
        this.openDrawerCount++
        this.openDrawer()
        this.openDrawerCount < 2 && this.$nextTick(() => {
          this.basicForm.setFieldsValue(this.listItem)
        })
      } else {
        this.closeDrawer()
      }
    },
    openDrawer() {
      this.visible = true
    },
    closeDrawer() {
      this.visible = false
      // this.basicForm.resetFields();
    },
    submitAuditForm(status) {
      this.basicForm.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const { remark } = values
          delete values.remark
          const items = Object.entries(values).map(item => {
            return {
              itemCode: item[0],
              itemResult: item[1]
            }
          })
          const data = {
            taskId: this.taskId,
            remark,
            items
          }
          this.auditApproval(data).then(res => {
            this.$message.success(this.$t('success'))
            this.closeParentModal()
          }).catch(e => {
            this.$message.error(e.message)
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    closeParentModal() {
      this.$emit('close')
    },
    requestDetail(id) {
      this.getExamineLogList({ orderId: id })
      Promise.all([
        this.getOrderDetail({ id }),
        this.getCustomerDetail({ id: this.custInfoId }),
        this.getApprovalListItem({ taskId: this.taskId }).then(res => {
          const { remark, items } = (res && res.data) || {}
          const form = (items || []).reduce((obj, item) => {
            obj[item.itemCode] = item.itemResult
            return obj
          }, {})
          this.listItem = { remark, ...form }
        })
      ]).then(res => {
        this.loading = false
      }).catch(e => {
        this.$message.error(e.message)
        this.loading = false
      })
    }
  },
  watch: {
    Q_cust_image_normal: {
      handler(newValue, oldValue) { //这里的第一个参数是改变后的值，第二个参数是原来的值
        console.log('当前的子选项值', this.image_normal_array)
        console.log('Q_cust_image_normal改后的值是：' + newValue)
        console.log('Q_cust_image_normal原来的值是：' + oldValue)
        if (newValue) {//如果被选中 多选条件被清空
          console.log('选中了正常')
          this.image_normal_array = []
          this.disable0ne = true//选了正常 禁用多选
        } else if (!newValue) {
          console.log('没选正常')
          this.disable0ne = false
          console.log('childValueOne', this.childValueOne)
          this.image_normal_array = this.childValueOne
          console.log('不禁用啦！', this.image_normal_array)
        }
      }
    },
    Q_cust_living_body_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.living_body_normal_array = []
          this.disableTwo = true
        } else if (!newValue) {
          this.disableTwo = false
          this.living_body_normal_array = this.childValueTwo
        }
      }
    },
    Q_cust_contactperson_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.contactperson_normal_array = []
          this.disableThree = true
        } else if (!newValue) {
          this.disableThree = false
          this.contactperson_normal_array = this.childValueThree
        }
      }
    },
    Q_contact_phone_normal: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.ontact_phone_array = []
          this.disableFour = true
        } else if (!newValue) {
          this.disableFour = false
          this.ontact_phone_array = this.childValueFour
        }
      }
    }


  }

}
</script>
<style lang='less' scoped>
.chose-one {
  .chose-one-item {
    height: 40px;
    font-weight: bold;
  }
}

.ant-checkbox-wrapper {
  height: 40px;
}

.ant-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

//.ant-col {
//  height: 40px;
//  margin-right: 10px;
//}

.tag {
  border-style: dashed;
  background: #fff;
}

.title {
  font-size: 14px;
  color: rgba(0, 0, 0, .65);
  font-weight: 400;
  margin-bottom: 12px;
}

.file-box {
  float: left;
  width: 200px;
  height: 200px;
  margin-right: 10px;
  margin: 0 8px 8px 0;

  .file-item {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 4px;

    .file-preview {
      padding: 8px;
      width: 182px;
      height: 142px;
    }

    .file-label {
      margin: 0;
      text-align: center;
      border-bottom: 1px solid #d9d9d9;
      padding: 8px;
      font-weight: 500;
      font-size: 16px;
    }
  }
}

.setting-drawer-handle {
  position: fixed;
  top: 240px;
  background: #1890ff;
  width: 32px;
  height: 32px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1301;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;
  transition: transform 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);

  &.active {
    transform: translateX(-600px);
    // right: 500px;
  }

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }
}

.audit-form {
  width: 100%;
  padding: 10px;
  border: 1px solid #e9e9e9;
  background: #fff;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

/deep/ .description-list .content {
  font-weight: 700;
}
</style>